import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Table,
} from "react-bootstrap";
import { stringDateTimeReceipt, stringYMDHMS3 } from "../Utility/dateTime";
import TablePagination from '@mui/material/TablePagination';
import { goToTop, handleDigit, searchFilterFunction, summary } from "../Utility/function";
import { Modal_Loading, Modal_OneInput, Modal_TwoInput } from "../modal";
import * as XLSX from 'xlsx';
import { fetchMember, updateFieldNormalMember } from "../redux/memberSlice";
import { OneButton, SearchAndDownload } from "../components";
import { initialMember } from "../configs";
import { db } from "../db/firestore";
import firebase from 'firebase/app';
import { pushByTwoFilter } from "../api/onesignal";


function MemberScreen() {
    const dispatch = useDispatch();
    const { shop:{ shopId, notiCredit = [] } } = useSelector(state=>state.shop)
    const { members, modal_Member } = useSelector(state=>state.member)
    const [currentDisplay, setCurrentDisplay] = useState([]) // จำนวนที่แสดงในหนึ่งหน้า
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [search, setSearch] = useState('')
    const [detail, setDetail] = useState({ totalBuy:0, totalPoint:0, totalCredit:0 });
    const { totalBuy, totalPoint, totalCredit } = detail;
    const [current, setCurrent] = useState(initialMember);
    const [point_Modal, setPoint_Modal] = useState(false);
    const [credit_Modal, setCredit_Modal] = useState(false);
    const { name, point, tel, totalCredit:thisTotalCredit, id } = current;
    const [amount, setAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [member_Modal, setMember_Modal] = useState(false);
  
    const handleChangePage = (event, newPage) => {
        setPage(newPage); // start form 0
        goToTop()
    };
  
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        goToTop()
    };

    useEffect(()=>{
        dispatch(fetchMember(shopId))
    },[])

    useEffect(()=>{
        let arr = members.map(a=>{
            const totalCredit = Number(a.credit) + summary(a?.creditArray||[],'remainCredit')

            return {
                ...a,
                totalCredit
            }
        });
        if(search){
            arr = searchFilterFunction(arr,search,'name')
        };

        const { totalBuy, totalPoint, totalCredit } = arr.reduce(
            ( acc, item ) => {
                acc.totalBuy += item.totalBuy;
                acc.totalPoint += item.point;
                acc.totalCredit += item.totalCredit;
                return acc
            },
            { totalBuy:0, totalPoint:0, totalCredit:0 }
        )

        let fData = arr.map((item,index)=>{return({ ...item, no:index +1 })}).filter((item,index)=>{return(index >=(page*rowsPerPage) && index <= ((page+1)*rowsPerPage)-1)})
        setCurrentDisplay(fData);
        setDetail({
            totalBuy:handleDigit(totalBuy),
            totalPoint,
            totalCredit:handleDigit(totalCredit)
        })
       

    },[page,rowsPerPage,members, search ]);

    const exportToXlsx = () => {
        // Define the headers
        const headers = [
          ["No.", "สมาชิก", "ติดต่อ", "วันที่สมัคร", "ซื้อล่าสุด", "ยอดซื้อสะสมปีนี้", "แต้มคงเหลือ", "ยอดเซ็นคงเหลือ"]
        ];
      
        // Map the data from the table
        const data = members.map((item, index) => [
          index + 1,
          item.name,
          item.tel,
          stringDateTimeReceipt(item.timestamp),
          stringDateTimeReceipt(item.lastTime),
          item.totalBuy,
          item.point,
          Number(item.credit) + summary(item?.creditArray||[],'remainCredit'),
        ]);
      
        // Add the total row with "รวม" spanning two columns
        data.push([
          "รวม", "","","","", // These will be merged
          totalBuy,
          totalPoint,
          totalCredit,
        ]);
      
        // Create the worksheet and workbook
        const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...data]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "สมาชิกทั้งหมด");
      
        // Merge "รวม" over two columns (A12:B12 if it's row 12)
        worksheet["!merges"] = [
          { s: { r: data.length, c: 0 }, e: { r: data.length, c: 4 } } // Merge first two cells of last row
        ];
      
        // Trigger file download
        XLSX.writeFile(workbook, `สมาชิกทั้งหมด ${stringYMDHMS3(new Date())}.xlsx`);
      };


    async function handleCredit(){
        setCredit_Modal(false);
        setAmount('');
        if(Number(amount) > thisTotalCredit){
            alert('ไม่สามารถชำระเงินมากกว่ายอดเซ็น')
        } else {
            const heading = `ลูกค้าชำระเงินเซ็น`
            let notificationContent = '';
            setLoading(true);
            try {
                const memberRef = db.collection('member').doc(id);
                const notiRef = db.collection('notification').doc();
                const paidRef = db.collection('paidHistory').doc();
                const updateFields =  await db.runTransaction(async (transaction) => {
                    const memberDoc = await transaction.get(memberRef);
            
                    if (!memberDoc.exists) return;
            
                    const { credit = 0, creditArray = [] } = memberDoc.data();
                    let totalCredit = credit;
                    let totalPay = Number(amount);
            
                    // Apply credit to totalPay
                    if (totalCredit > 0) {
                        const applied = Math.min(totalCredit, totalPay);
                        totalCredit -= applied;
                        totalPay -= applied;
                    }
            
                    // Apply remaining pay to creditArray
                    const newCreditArray = creditArray.map(item => {
                        if (totalPay <= 0) return item;
            
                        const applied = Math.min(item.remainCredit, totalPay);
                        totalPay -= applied;
                        return {
                            ...item,
                            remainCredit: item.remainCredit - applied
                        };
                    });

                    const existCredit = Number(totalCredit) + summary(newCreditArray.filter(a=>a.remainCredit>0),'remainCredit');
                    notificationContent = `ลูกค้า ${name}\nยอดเงินชำระ ${handleDigit(Number(amount))} บาท\nยอดค้างชำระคงเหลือ ${existCredit} บาท`
                    const memberObj = {
                        credit: totalCredit,
                        creditArray: newCreditArray.filter(a=>a.remainCredit>0)
                    };
                    // 1. upload member
                    transaction.update(memberRef, memberObj);

                    // 2. add noti
                    transaction.set(notiRef,{
                        heading, 
                        shopId, 
                        notificationContent, 
                        categoryId:4,
                        timestamp:firebase.firestore.FieldValue.serverTimestamp() 
                    })

                    // 3. add PaidHistory
                    transaction.set(paidRef,{
                        shopId, 
                        paid:amount,
                        existCredit,
                        memberId:id,
                        timestamp:firebase.firestore.FieldValue.serverTimestamp(),
                        billDate:stringYMDHMS3(new Date())
                    })


                    return memberObj;
                });

                // 3. แจ้งเตือนผ่านแอป
                notiCredit.forEach(item => {
                    pushByTwoFilter({ id: item, shopId, content: notificationContent, heading, data : { sound:heading } });
                });

                // 4. แจ้งเตือนผ่านไลน์

                //5. อัปเดต normal member
                dispatch(updateFieldNormalMember({ id, updateFields }))
            } catch (error) {
                console.error('Transaction failed:', error);
            } finally {
                setLoading(false)
            }
        } 
    };

    async function handlePoint(){
        setPoint_Modal(false);
        setAmount('');
        if(Number(amount) > Number(point)){
            alert('จำนวนแต้มสะสมไม่เพียงพอ')
        } else {
            let currentPoint = 0;
            setLoading(true)
            try {
                const memberRef = db.collection('member').doc(id);
                await db.runTransaction( async (transaction)=>{
                    const memberDoc = await transaction.get(memberRef);
                    if(memberDoc.exists){
                        const { point } = memberDoc.data();
                        const newPoint = Number(point) - Number(amount)
                        currentPoint = newPoint;
                        transaction.update(memberRef, { point: newPoint });
                    }
                })
                dispatch(updateFieldNormalMember({ id, updateFields:{ point:currentPoint }}))
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }  
    };

    function handleMember(){
        setMember_Modal(false);
        setLoading(true)
        try {
            db.collection('member').doc(id).update({ name, tel })
            dispatch(updateFieldNormalMember({ id, updateFields:{ name, tel }}))
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }


  return (
    <div style={{minHeight:'100vh'}} >
        <Modal_OneInput
            show={credit_Modal}
            onHide={()=>{setCredit_Modal(false)}}
            header={`บัญชีเงินเซ็นของ ${name} (${thisTotalCredit}) บาท`}
            onChange={setAmount}
            value={amount}
            placeholder='จำนวนเงินที่ต้องการชำระ'
            onClick={handleCredit}
        />
        <Modal_OneInput
            show={point_Modal}
            onHide={()=>{setPoint_Modal(false)}}
            header={`บัญชีคะแนนของ ${name} (${point}) บาท`}
            onChange={setAmount}
            value={amount}
            placeholder='จำนวนคะแนนที่ต้องการตัดออก'
            onClick={handlePoint}
        />
        <Modal_TwoInput
            show={member_Modal}
            onHide={()=>{setMember_Modal(false)}}
            header='แก้ไขโปรไฟล์สมาชิก'
            onChange={name=>setCurrent(prev=>({...prev,name}))}
            onChange2={tel=>setCurrent(prev=>({...prev,tel}))}
            value={name}
            value2={tel}
            placeholder='กรอกชื่อสมาชิก'
            placeholder2='กรอกหมายเลขโทรศัพท์'
            onClick={handleMember}
        />
        <Modal_Loading show={modal_Member || loading} />
        <h1>สมาชิก</h1>
        <SearchAndDownload
            {...{
              placeholder:'ค้นหาด้วยชื่อ',
              search,
              setSearch,
              exportToXlsx
            }}
        />
        <h4>&emsp;ค้นพบ {members.length} สมาชิก</h4> 
        <br/>
        <Table striped bordered hover responsive  variant="light"   >
            <thead  >
                <tr>
                    <th style={{textAlign:'center', width: '10%'}} >No.</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >สมาชิก</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >ติดต่อ</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >วันที่สมัคร</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >ซื้อล่าสุด</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >ยอดซื้อสะสมปีนี้</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >แต้มคงเหลือ</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >ยอดเซ็นคงเหลือ</th>
                    <th style={{textAlign:'center', width:'15%', minWidth:'120px' }} >จัดการ</th>

                </tr>
            </thead>
            <tbody  >
            {currentDisplay.map((item, index) => {
                const { name, tel, timestamp, lastTime, totalBuy = 0, point, totalCredit } = item;
                return <tr  style={{cursor: 'pointer'}} key={index} >
                            <td style={{textAlign:'center'}}>{index+1}.</td>
                            <td style={{textAlign:'center'}}>{name}</td>
                            <td style={{textAlign:'center'}}>{tel}</td>
                            <td style={{textAlign:'center'}}>{stringDateTimeReceipt(timestamp)}</td>
                            <td style={{textAlign:'center'}}>{stringDateTimeReceipt(lastTime)}</td>
                            <td style={{textAlign:'center'}}>{totalBuy}</td>
                            <td onClick={()=>{setPoint_Modal(true);setCurrent(item)}}  style={{textAlign:'center'}}>{point}&emsp;<i class="bi bi-pen"></i></td>
                            <td onClick={()=>{setCredit_Modal(true);setCurrent(item)}}  style={{textAlign:'center'}}>{totalCredit}&emsp;<i class="bi bi-pen"></i></td>
                            <td style={{textAlign:'center'}}>
                                <OneButton {...{ text:'แก้ไข', submit:()=>{setCurrent(item);setMember_Modal(true)}, variant:'warning' }} />
                            </td>
                           
                        </tr>
            })}
            <tr>
                <td colSpan='5' style={{textAlign:'center'}}>รวม</td>
                <td style={{textAlign:'center'}}>{totalBuy}</td>
                <td style={{textAlign:'center'}}>{totalPoint}</td>
                <td style={{textAlign:'center'}}>{totalCredit}</td>
                <td style={{textAlign:'center'}}></td>
            </tr>
            </tbody>
        </Table>
        <TablePagination
            component="div"
            count={members.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
    </div>
  );
};

const styles = {
    container2 : {
      display:'flex',justifyContent:'space-between',marginRight:'1rem'
    },
 
  }

export default MemberScreen;